import { api } from "../index";
import { PaginatedResponse } from "../types";
import { toFrontStatus, toBackendStatus } from "./status";

export interface AdminCollaborationSummary {
  colaboracao_id: number;
  nome_especie: string;
  status: string; // front mapped
  user?: { user_id: number; nome_completo?: string };
  data?: string;
  pais?: string;
  estado?: string;
  municipio?: string;
  regiao?: string;
  created_at?: string;
}

export interface AdminCollaborationDetail extends AdminCollaborationSummary {
  latitude?: string;
  longitude?: string;
  altitude?: string;
  coletor?: string;
  instituicao_coletor?: string;
  autor_foto?: string;
  instituicao_autor?: string;
  SISBIO?: string;
  SISGEN?: string;
  observacoes?: string;
  imagens?: any[]; // pode ser enriquecido depois
}

export interface CollaborationFilters {
  user_id?: number;
  status?: string;
  nome_especie?: string;
  pais?: string;
  estado?: string;
  regiao?: string;
  municipio?: string;
  page?: number; // reserva para backend futuro
  limit?: number; // reserva
}

export async function listAllCollaborations(
  token?: string | null,
  filters?: CollaborationFilters,
  page: number = 1,
  pageSize: number = 20
): Promise<PaginatedResponse<AdminCollaborationSummary>> {
  const r = await api.get(
    "/colaboracoes",
    {
      params: {
        page,
        pageSize,
        ...(filters?.user_id ? { user_id: filters.user_id } : {}),
        ...(filters?.status ? { status: toBackendStatus(filters.status) } : {}),
      },
      headers: token ? { "X-CSRF-Token": token } : undefined,
    }
  );
  const data = r.data as PaginatedResponse<AdminCollaborationSummary>;
  return {
    ...data,
    items: data.items.map((c: any) => ({
      ...c,
      status: toFrontStatus(c.status),
    })),
  };
}

export function applyClientFilters(
  data: AdminCollaborationSummary[],
  filters?: CollaborationFilters
) {
  if (!filters) return data;
  return data.filter((item) => {
    if (filters.status && item.status !== filters.status) return false;
    if (filters.nome_especie && item.nome_especie !== filters.nome_especie)
      return false;
    if (filters.pais && item.pais !== filters.pais) return false;
    if (filters.estado && item.estado !== filters.estado) return false;
    if (filters.regiao && item.regiao !== filters.regiao) return false;
    if (filters.municipio && item.municipio !== filters.municipio) return false;
    return true;
  });
}

export async function getCollaborationById(
  id: number,
  token?: string | null
): Promise<AdminCollaborationDetail> {
  const r = await api.get(
    `/colaboracoes/${id}`,
    token ? { headers: { "X-CSRF-Token": token } } : undefined
  );
  const c = r.data;
  return { ...c, status: toFrontStatus(c.status) };
}

export async function updateCollaborationStatus(
  id: number,
  newStatusFront: string,
  token: string
) {
  const status = toBackendStatus(newStatusFront);
  const r = await api.patch(
    `/colaboracoes/${id}/status`,
    { status },
    { headers: { "X-CSRF-Token": token } }
  );
  return { ...r.data, status: toFrontStatus(r.data.status) };
}

export async function deleteCollaborationAdmin(id: number, token: string) {
  const r = await api.delete(`/colaboracoes/${id}`, {
    headers: { "X-CSRF-Token": token },
  });
  return r.data;
}
